import * as Sentry from "@sentry/browser";

/*
* Run custom function based on cookie categorization if the user has accepted the cookie policy
 */
const ifCookieCategorizationCallback = (config = {}) => {
    const OnetrustActiveGroups = config.OnetrustActiveGroups || '';
    const cookies = config.cookies || [];

    for(let cookie of cookies) {
        if(OnetrustActiveGroups === ',C0001,' && cookie.refusedCookieCallback) {
            cookie.refusedCookieCallback();

            return;
        }

        if(OnetrustActiveGroups.indexOf(cookie.categorieID) > -1 && cookie.acceptedCookieCallback) {
            if(cookie.hasBeenInit === false) {
                cookie.acceptedCookieCallback();
                cookie.hasBeenInit = true;
            }
        } else if(OnetrustActiveGroups.indexOf(`${cookie.categorieID}`) <= -1 && cookie.refusedCookieCallback) {
            if(cookie.hasBeenInit === false) {
                cookie.refusedCookieCallback();
                cookie.hasBeenInit = true;
            }
        }
    }
};

/*
* Append a div element and add a data-attribute that contain OneTrust categories
* The observer use this DIV to watch changes on the categories
* <div id="OnetrustActiveGroups" data-otgroups=",C0001," class="hiddendiv common"></div>
*/
const OTGroupsObserverDiv = (groups) => {
    const OTGroups = document.createElement('div');

    OTGroups.classList.add('hiddendiv');
    OTGroups.classList.add('common');
    OTGroups.id = 'OnetrustActiveGroups';
    OTGroups.dataset.otgroups = groups;

    document.body.appendChild(OTGroups);
};

/*
* Function called by the OneTrust script to update the accepted categories
 */
window.OptanonWrapper = function OptanonWrapper() {
    const categories = OnetrustActiveGroups.split(',');
    let classOnBody = document.body.className ? document.body.className.split(' ') : '';

    if(classOnBody) {
        classOnBody = classOnBody.filter(el => !el.includes('ot-')).join(" ");
    }

    if(!document.getElementById('OnetrustActiveGroups')) {
        OTGroupsObserverDiv(OnetrustActiveGroups);
    }

    document.getElementById('OnetrustActiveGroups').dataset['otgroups'] = OnetrustActiveGroups;

    document.body.setAttribute('class', classOnBody);

    for(let categorie of categories) {
        if(categorie) {
            document.body.classList.add(`ot-${categorie}`);
        }
    }
};

/*
* Create an array of cookie categorization based on Onetrust scan and init function related on this category
* Add an observer to watch the accepted categories
* https://coveo.my.onetrust.com/cookies/categorizations?tab=Categories
* acceptedCookieCallback: Init function when the user accepted the cookies
* refusedCookieCallback: Init function if the user refused the cookies
 */
const acceptedCookiePolicy = (config = {}) => {
    const ifStrictlyNecessaryCookies = config.ifStrictlyNecessaryCookies || null;
    const ifPerformanceCookies = config.ifPerformanceCookies || null;
    const ifFunctionalCookies = config.ifFunctionalCookies || null;
    const ifTargetingCookies = config.ifTargetingCookies || null;
    const ifSocialMediaCookies = config.ifSocialMediaCookies || null;

    const ifNoPerformanceCookies = config.ifNoPerformanceCookies || null;
    const ifNoFunctionalCookies = config.ifNoFunctionalCookies || null;
    const ifNoTargetingCookies = config.ifNoTargetingCookies || null;
    const ifNoSocialMediaCookies = config.ifNoSocialMediaCookies || null;

    let observer = null;
    const cookieCategorization = [
        {
            categorieID: 'C0002',
            acceptedCookieCallback: ifPerformanceCookies,
            refusedCookieCallback: ifNoPerformanceCookies,
            hasBeenInit: false
        },
        {
            categorieID: 'C0003',
            acceptedCookieCallback: ifFunctionalCookies,
            refusedCookieCallback: ifNoFunctionalCookies,
            hasBeenInit: false
        },
        {
            categorieID: 'C0004',
            acceptedCookieCallback: ifTargetingCookies,
            refusedCookieCallback: ifNoTargetingCookies,
            hasBeenInit: false
        },
        {
            categorieID: 'C0005',
            acceptedCookieCallback: ifSocialMediaCookies,
            refusedCookieCallback: ifNoSocialMediaCookies,
            hasBeenInit: false
        }
    ];

    const initFunctionWhenDataChange = (mutations) => {
        for (let mutation of mutations) {
            if (mutation.type === 'attributes') {
                if(OnetrustActiveGroups === ',C0001,') {
                    if(ifStrictlyNecessaryCookies) {
                        ifStrictlyNecessaryCookies();
                    }
                } else {
                    ifCookieCategorizationCallback({
                        OnetrustActiveGroups,
                        cookies: cookieCategorization
                    });
                }

                break;
            }
        }
    };

    const watchOnetrustActiveGroups = setInterval(() => {
        if(typeof OptanonWrapper !== "undefined" && document.getElementById('OnetrustActiveGroups')) {
            const OTElement = document.getElementById('OnetrustActiveGroups');

            observer = new MutationObserver(initFunctionWhenDataChange);
            observer.observe(OTElement, { attributes: true });

            ifCookieCategorizationCallback({
                OnetrustActiveGroups,
                cookies: cookieCategorization
            });

            clearInterval(watchOnetrustActiveGroups);
        }
    }, 250);

    /*
    * Disabled the cookie policy function if onetrust script is not loaded for unknow reason.
    * The script response time is ~55ms
    * OnetrustActiveGroups variable is set after the https://cdn.cookielaw.org/scripttemplates/otSDKStub.js was initialized
     */
    setTimeout(() => {
        if(typeof OnetrustActiveGroups === 'undefined') {
            window.OnetrustActiveGroups = ',C0001,C0003,C0002,C0004,C0005,';

            OptanonWrapper();
            ifCookieCategorizationCallback({
                OnetrustActiveGroups,
                cookies: cookieCategorization
            });

            clearInterval(watchOnetrustActiveGroups);

            // Enable Sentry if Onetrust fail
            console.warn('OneTrust cookie policy script failed to load');
            Sentry.captureException('OneTrust cookie policy script failed to load');
        }
    }, 3000);
};


export default acceptedCookiePolicy;